<template>
    <div class="rounded-xl w-full" :class="[
        gray ? 'bg-slate-100' : 'bg-white',
        !noShadow && 'shadow-md',
    ]">
        <div class="px-4 py-5 sm:p-6 w-full mx-auto h-full" :class="flex && 'flex'">
            <div v-if="hasHeader || $slots.buttons" :class="hasContent && 'mb-4'" class="flex flex-col sm:flex-row justify-between">
                <div v-if="hasHeader">
                    <QrHeader v-if="header" :text="header" :trans="headerTrans"/>

                    <QrSubHeader v-if="subHeader" :text="subHeader" :trans="subHeaderTrans"/>
                </div>

                <div v-if="$slots.buttons" class="space-x-2 ml-0 sm:ml-auto mt-2 sm:mt-0">
                    <slot name="buttons"/>
                </div>
            </div>

            <slot/>
        </div>
    </div>
</template>

<script setup>
import QrHeader from "@/components/application-ui/content/QrHeader.vue";
import QrSubHeader from "@/components/application-ui/content/QrSubHeader.vue";
import { useSlots, computed } from "vue";

const props = defineProps({
    header: String,
    headerTrans: String,
    subHeader: String,
    subHeaderTrans: String,
    gray: Boolean,
    noShadow: Boolean,
    flex: Boolean,
})

const slots = useSlots();

const hasHeader = computed(() => {
    return slots.header || props.header || slots.subHeader || props.subHeader;
});

const hasContent = computed(() => {
    return slots.default;
});
</script>
